import { DashboardTourEnum } from "enums/dashboard-tour.enum";
import {
  AUTOCALLER_SETUP_WEBINAR_URL,
  IVT_SETUP_WEBINAR_URL,
  LEAD_RESPONDER_SETUP_WEBINAR_URL,
} from "./external-paths";
import runtimeEnv from "@mars/heroku-js-runtime-env";

export type ToolTours =
  | DashboardTourEnum.AUTOCALLER_TOUR
  | DashboardTourEnum.IVT_TOUR
  | DashboardTourEnum.LEAD_RESPONDER_TOUR;

export const getToolToursLinks = (): {
  [key in ToolTours]: {
    guideLink: string;
    webinarLink: string;
  };
} => {
  const env = runtimeEnv();
  const guidesUrl = env.REACT_APP_GUIDES_URL;

  return {
    [DashboardTourEnum.AUTOCALLER_TOUR]: {
      guideLink: `${guidesUrl}/setting-up-autocaller`,
      webinarLink: AUTOCALLER_SETUP_WEBINAR_URL,
    },
    [DashboardTourEnum.IVT_TOUR]: {
      guideLink: `${guidesUrl}/turning-on-your-instant-valuation-tool`,
      webinarLink: IVT_SETUP_WEBINAR_URL,
    },
    [DashboardTourEnum.LEAD_RESPONDER_TOUR]: {
      guideLink: `${guidesUrl}/setting-up-lead-responder`,
      webinarLink: LEAD_RESPONDER_SETUP_WEBINAR_URL,
    },
  };
};
